module.exports = __webpack_public_path__ + "static/media/icon-lojas-deselecionado.15561480.svg";